import _ from 'lodash';
import { TrkPageType, TrkTag } from '@nerdwallet/nw-client-lib/trk-helper';

import { CC_PORTAL } from '../redirect-uris';
import internalLink from '../internal-link';

// Front pageType !== taxonomy.pageType
const frontPagePageType = TrkPageType.hub;
const frontPagePath = '/';

/**
 * Wrapper around internalLink that sets the route path and trk_pageType
 * @param {string} toPath - destination path
 * @param {Object=} options - to be passed to internalLink
 * @param {Object=} options.nonTrkParams - params not for trk purposes (e.g. redirect_uri)
 * @param {Object=} options.trkParams - params to be passed to internalLink
 * @param {boolean=} options.isStub - stub param to be passed to internalLink
 */
export function internalLinkFromFrontPage(toPath, options = {}) {
  return internalLink(frontPagePath, toPath, {
    trkParams: _.assign(
      {
        [TrkTag.pageType]: frontPagePageType,
      },
      options.trkParams
    ),

    // Pass these through
    nonTrkParams: options.nonTrkParams,
    isStub: options.isStub,
  });
}

/**
Wrapper around internalLinkFromFrontPage that sets params for registration
and returns a stub that can be further set with trk_element, trk_location,
trk_copy by rendering component
*/
const registration = internalLinkFromFrontPage('/home/register', {
  nonTrkParams: {
    flow: 'credit-score',
    redirect_uri: CC_PORTAL,
  },
  isStub: true,
});

export const links = {
  registration,
};
